<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>
      </div>

      <div class="content-container">
        <div class="actions-row">
          <p-button
            [icon]="
              'pi pi-refresh' +
              (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
            "
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="refreshData()"
          />

          <p-button
            icon="pi pi-filter"
            severity="info"
            [outlined]="!filtersDialogVisible"
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="toggleFilters()"
            [label]="appliedFiltersCount"
          />

          <input
            #dataSearch
            type="text"
            pInputText
            id="search-input"
            (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
            [placeholder]="t(SEARCH_PLACEHOLDER)"
            class="search-input"
          />

          <p-button
            [label]="t(ADD_BUTTON_LABEL)"
            icon="pi pi-plus"
            class="add-record-button"
            (click)="openFormDialog()"
          />

          <p-button
            icon="pi pi-list-check"
            severity="secondary"
            [disabled]="selectedRows.length === 0"
            (click)="batchMenuElement.toggle($event)"
          />

          <p-menu
            #batchMenuElement
            [model]="batchMenu"
            [popup]="true"
            appendTo="body"
          />
        </div>

        <p-skeleton
          class="skeleton-loader"
          height="100%"
          width="100%"
          [class.visible]="(dataLoadingUI$ | async) ?? true"
        />

        <p-table
          #dataTable
          class="table"
          id="table"
          [value]="data"
          [(selection)]="selectedRows"
          [rowHover]="true"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
          sortMode="single"
          selectionMode="multiple"
          [rowTrackBy]="_dataTrackBy"
          [metaKeySelection]="true"
          [resizableColumns]="true"
          columnResizeMode="fit"
          [globalFilterFields]="dataFilterFields"
          stripedRows
          [scrollable]="true"
          [class.visible]="!((dataLoadingUI$ | async) ?? true)"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <th [pSortableColumn]="col.field" pResizableColumn>
                    <div class="table-header-row">
                      <span class="header-label">{{
                        t(col.header, col.headerParams)
                      }}</span>
                      <div class="header-buttons">
                        <p-sortIcon [field]="col.field" />
                      </div>
                    </div>
                  </th>
                }
              }
            </tr>
          </ng-template>
          <ng-template #body let-record let-rowIndex="rowIndex">
            <tr
              [pSelectableRow]="record"
              [pSelectableRowIndex]="rowIndex"
              (contextmenu)="$event.preventDefault(); openFormDialog(record)"
              (longPress)="openFormDialog(record)"
              appLongPress
            >
              <td (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="record" />
              </td>
              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <td>
                    <!-- CELLA -->
                    @if (col.wrapper) {
                      <ng-container
                        *ngComponentOutlet="
                          col.wrapper;
                          inputs: parseWrapperInputs(col, [
                            record,
                            getCellData(col, record),
                          ])
                        "
                      ></ng-container>
                    } @else {
                      <span [innerHTML]="getCellData(col, record)"></span>
                    }
                  </td>
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewRecordDialog
        ? t(NEW_RECORD_TITLE)
        : t(EDIT_RECORD_TITLE, { code: formDialogData.code })
    "
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)', height: 'min(90vh, 730px)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="
      dataForm.reset(formDialogData);
      parametersForm.reset(formDialogData);
      activeDialogTab = 'data'
    "
  >
    <div class="buttons-row">
      <p-button
        [label]="t('data')"
        icon="pi pi-pencil"
        [severity]="activeDialogTab == 'data' ? 'primary' : 'secondary'"
        [rounded]="true"
        size="small"
        (click)="activeDialogTab = 'data'"
      />

      <p-button
        [label]="t('parameters')"
        icon="pi pi-cog"
        [severity]="activeDialogTab == 'parameters' ? 'primary' : 'secondary'"
        [rounded]="true"
        size="small"
        (click)="activeDialogTab = 'parameters'"
      />
    </div>

    <form
      class="data-form"
      #dataForm="ngForm"
      [class.visible]="activeDialogTab == 'data'"
    >
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #taskCodeInput="ngModel"
          pInputText
          id="task-code-input"
          name="code"
          [(ngModel)]="formDialogData.code"
          autocomplete="off"
          required
          [disabled]="(dataLoading$ | async) ?? true"
        />
        <label for="task-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? DESCRIPTION ----------------------------->
      <p-floatlabel variant="in">
        <input
          #planDescriptionInput="ngModel"
          pInputText
          id="plan-description-input"
          name="description"
          [(ngModel)]="formDialogData.description"
          autocomplete="off"
          required
          [disabled]="(dataLoading$ | async) ?? true"
        />
        <label for="plan-description-input">
          {{ t("description") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? MODELS ---------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #planModelsInput="ngModel"
          inputId="plan-model-input"
          name="model"
          [(ngModel)]="formDialogData.models"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          [options]="bikesModels"
          optionLabel="code"
          optionValue="modelId"
          appendTo="body"
          styleClass="w-full"
        />
        <label for="plan-model-input">
          {{ t("models") }}
        </label>
      </p-floatlabel>

      <!--? ACTIVE ---------------------------------->
      <div class="select-button-float-label">
        <p-selectbutton
          id="plan-active-input"
          name="active"
          [(ngModel)]="formDialogData.active"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('active'), value: true },
            { label: t('notActive'), value: false },
          ]"
          [allowEmpty]="false"
        />
        <label for="plan-active-input">
          {{ t("status") }}
        </label>
      </div>

      <!--? PREAUTHORIZATION AMOUNT ------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planPreauthInput="ngModel"
          id="plan-preauthorization-input"
          name="preauthorizationAmount"
          [(ngModel)]="formDialogData.preauthorizationAmount"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-preauthorization-input">
          {{ t("preauthorization") }}
        </label>
      </p-floatlabel>

      <!--? DETAILS ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #planDetailsInput="ngModel"
          id="plan-details-input"
          name="details"
          [(ngModel)]="formDialogData.details"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          styleClass="w-full"
          rows="3"
          style="resize: none"
        ></textarea>
        <label for="plan-details-input">
          {{ t("details") }}
        </label>
      </p-floatlabel>

      <!--? NOTES ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #planNotesInput="ngModel"
          id="plan-notes-input"
          name="notes"
          [(ngModel)]="formDialogData.notes"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          styleClass="w-full"
          rows="4"
          style="resize: none"
        ></textarea>
        <label for="plan-notes-input">
          {{ t("notes") }}
        </label>
      </p-floatlabel>
    </form>

    <form
      class="parameters-form"
      #parametersForm="ngForm"
      [class.visible]="activeDialogTab == 'parameters'"
    >
      <p class="sep-label">{{ t("recurringCosts") }}</p>

      <!--? UNLOCK COST ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planCpuInput="ngModel"
          id="plan-uc-input"
          name="unlockCost"
          [(ngModel)]="formDialogData.unlockCost"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-uc-input">
          {{ t("unlockCost") }}
        </label>
      </p-floatlabel>

      <!--? COST PER MINUTE ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planCpmInput="ngModel"
          id="plan-cpm-input"
          name="costPerMinute"
          [(ngModel)]="formDialogData.minCost"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-cpm-input">
          {{ t("costPerMinute") }}
        </label>
      </p-floatlabel>

      <!--? COST PER KM ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planCpkInput="ngModel"
          id="plan-cpk-input"
          name="costPerKm"
          [(ngModel)]="formDialogData.kmCost"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-cpk-input">
          {{ t("costPerKilometer") }}
        </label>
      </p-floatlabel>

      <!--? PAUSE COST PER MINUTE ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planPcInput="ngModel"
          id="plan-pc-input"
          name="pauseCost"
          [(ngModel)]="formDialogData.pauseCost"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-pc-input">
          {{ t("pauseCost") }}
        </label>
      </p-floatlabel>

      <p class="sep-label">{{ t("reservationConstraints") }}</p>

      <!--? RESERVATION TIMEOUT ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planRtInput="ngModel"
          id="plan-rt-input"
          name="reservationTimeout"
          [(ngModel)]="formDialogData.reservationTimeout"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
          suffix=" min"
        />
        <label for="plan-rt-input">
          {{ t("reservationTimeout") }}
        </label>
      </p-floatlabel>

      <!--? RESERVATION PENALTY COST ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planRpcInput="ngModel"
          id="plan-rpc-input"
          name="reservationPenaltyCost"
          [(ngModel)]="formDialogData.reservationPenaltyCost"
          autocomplete="off"
          [disabled]="
            (formDialogData.reservationTimeout ?? 0) == 0 ||
            ((dataLoading$ | async) ?? true)
          "
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
          [required]="(formDialogData.reservationTimeout ?? 0) > 0"
        />
        <label for="plan-rpc-input">
          {{ t("reservationPenaltyCost") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <p class="sep-label">{{ t("durationConstraints") }}</p>

      <!--? MAX RIDE DURATION ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planMrduInput="ngModel"
          id="plan-mrdu-input"
          name="maxRideDuration"
          [(ngModel)]="formDialogData.maxRideDuration"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
          suffix=" min"
        />
        <label for="plan-mrdu-input">
          {{ t("maxRideDuration") }}
        </label>
      </p-floatlabel>

      <!--? EXTRA DURATION PENALTY COST ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planEmpcInput="ngModel"
          id="plan-empc-input"
          name="extraMinutePenaltyCost"
          [(ngModel)]="formDialogData.extraMinutePenaltyCost"
          autocomplete="off"
          [disabled]="
            (formDialogData.maxRideDuration ?? 0) == 0 ||
            ((dataLoading$ | async) ?? true)
          "
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
          [required]="(formDialogData.maxRideDuration ?? 0) > 0"
        />
        <label for="plan-empc-input">
          {{ t("extraMinutePenaltyCost") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <p class="sep-label">{{ t("distanceConstraints") }}</p>

      <!--? MAX RIDE DISTANCE ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planMrdiInput="ngModel"
          id="plan-mrdi-input"
          name="maxRideDistance"
          [(ngModel)]="formDialogData.maxRideDistance"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
          suffix=" km"
        />
        <label for="plan-mrdi-input">
          {{ t("maxRideDistance") }}
        </label>
      </p-floatlabel>

      <!--? EXTRA KM PENALTY COST ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planEkpcInput="ngModel"
          id="plan-ekpc-input"
          name="extraKmPenaltyCost"
          [(ngModel)]="formDialogData.extraKmPenaltyCost"
          autocomplete="off"
          [disabled]="
            (formDialogData.maxRideDistance ?? 0) == 0 ||
            ((dataLoading$ | async) ?? true)
          "
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
          [required]="(formDialogData.maxRideDistance ?? 0) > 0"
        />
        <label for="plan-ekpc-input">
          {{ t("extraKmPenaltyCost") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <p class="sep-label">{{ t("priceConstraints") }}</p>

      <!--? MIN PRICE ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planMinpInput="ngModel"
          id="plan-minp-input"
          name="minPrice"
          [(ngModel)]="formDialogData.minPrice"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-minp-input">
          {{ t("minPrice") }}
        </label>
      </p-floatlabel>

      <!--? MAX PRICE ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planMaxpInput="ngModel"
          id="plan-maxp-input"
          name="maxPrice"
          [(ngModel)]="formDialogData.maxPrice"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          min="0"
          step="0.01"
          [showButtons]="true"
          buttonLayout="stacked"
          mode="currency"
          currency="EUR"
        />
        <label for="plan-maxp-input">
          {{ t("maxPrice") }}
        </label>
      </p-floatlabel>

      <p class="sep-label">{{ t("offers") }}</p>

      <!--? FREE MINS ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planFmInput="ngModel"
          id="plan-fm-input"
          name="freeMins"
          [(ngModel)]="formDialogData.freeMins"
          autocomplete="off"
          [disabled]="
            ((dataLoading$ | async) ?? true) ||
            (formDialogData.minCost ?? 0) == 0
          "
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
          suffix=" min"
        />
        <label for="plan-fm-input">
          {{ t("freeMins") }}
        </label>
      </p-floatlabel>

      <!--? FREE KM ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #planFkInput="ngModel"
          id="plan-fk-input"
          name="freeKm"
          [(ngModel)]="formDialogData.freeKm"
          autocomplete="off"
          [disabled]="
            ((dataLoading$ | async) ?? true) ||
            (formDialogData.kmCost ?? 0) == 0
          "
          min="0"
          step="1"
          [showButtons]="true"
          buttonLayout="stacked"
          suffix=" km"
        />
        <label for="plan-fk-input">
          {{ t("freeKm") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      @if (!isNewRecordDialog) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteRecord()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(dataLoading$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog()"
        [outlined]="true"
      />
      <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord()"
        [disabled]="
          ((dataLoading$ | async) ?? true) ||
          !dataForm.valid ||
          !parametersForm.valid
        "
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm"></form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters.values = {}; refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>
</ng-container>
